<!-- <div class="noActiveBots">
    <img src="assets/images/noactivebots.svg" class="img-fluid" alt="icon" />
    <p>You don’t have active bots</p>
    <button class="btn startButton">Start NewBot</button>
</div> -->
<div class="bot-order" *ngIf="!showNext">
  <div class="bot-order-head">
    <h4>Create GRID Bot</h4>
    <button class="bot-clear">
      <!-- <img src="assets/images/botclear.svg" alt="close" title="close" /> -->
    </button>
  </div>
  <!-- <div class="bot-order-select">
    <span class="exchange">Exchange</span>
    <div class="drpdwn_box">
      <div class="dropdown">
        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
          data-bs-toggle="dropdown" aria-expanded="false" disabled>
          <img src="assets/images/binance.svg" class="img-fluid" alt="icon" />
          Binance
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <div class="dropSearch">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Exchange Name" />
              <span class="input-group-text"><i class="bi bi-search"></i></span>
            </div>
          </div>
          <ul>
            <li>
              <a class="dropdown-item" role="button" href="javascript:void(0)"><img src="assets/images/binance.svg"
                  class="img-fluid" alt="icon" />
                Binance</a>
            </li>
            <li>
              <a class="dropdown-item" role="button" href="javascript:void(0)"><img src="assets/images/bybit.svg"
                  class="img-fluid" alt="icon" />
                Bybit</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div> -->
  <div class="bot-order-select">
    <span class="exchange">Pairs</span>
    <div class="drpdwn_box">
      <div class="dropdown">
        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
          data-bs-toggle="dropdown"
          aria-expanded="false">{{pairData.firstCurrencySymbol}}/{{pairData.secondCurrencySymbol}}
        </button>
        <br>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <div class="dropSearch">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search Pair" (input)="handleSearchPair($event)" />
              <span class="input-group-text"><i class="bi bi-search"></i></span>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-hover pairTableColor" id="pairTable">
              <thead>
                <tr>
                  <th>Pair</th>
                  <th>Price</th>
                  <th>24H Change</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let pair of pairs | textFilter: 'tikerRoot': searchPair; let i = index"
                  [ngClass]="{ 'active': i === 0 }" (click)="changePair(pair)">

                  <!-- Pair Column -->
                  <td>
                    {{ pair.firstCurrencySymbol }}/{{ pair.secondCurrencySymbol }}
                  </td>

                  <!-- Price Column -->
                  <td>
                    {{ nFormatter(truncateDecimals(pair.markPrice, pair.secondFloatDigit)) }}
                  </td>

                  <!-- 24H Change Column -->
                  <td>
                    <span [ngClass]="pair.change > 0 ? 'greenTxt' : 'redText'" class="d-flex align-items-center">
                      {{ nFormatter(truncateDecimals(pair.change, pair.secondFloatDigit)) }}
                      <img *ngIf="pair.change > 0" src="assets/images/uparrow.svg" alt="Up" title="Up"
                        class="ms-1 pair-icon" />
                      <img *ngIf="pair.change <= 0" src="assets/images/downarrow.svg" alt="Down" title="Down"
                        class="ms-1 pair-icon" />
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="createbot_box">
    <div class="inputgrp_box">
      <div class="w-100 input-group">
        <label class="grey">Investment, {{pairData.secondCurrencySymbol}}</label>
        <input aria-label="investment" aria-describedby="basic-addon1" (input)="handleTradeChange($event)"
          name="investment" class="form-control" type="text" min="0.000001" (wheel)="onWheel($event)"
          inputmode="decimal" [ngModel]="formValue.investment" pattern="[0-9]*[.]?[0-9]*"
          [appDecimalLimit]="pairData.secondFloatDigit" decimals />
        <!-- <span class="grey input-group-text" id="basic-addon1">≈ 3893.72USD</span> -->
      </div>
      <span class="required" *ngIf="serverErrors?.investment">{{
        serverErrors.investment
        }}</span>
    </div>
  </div>
  <!-- <ngx-slider [(value)]="value" [options]="options"></ngx-slider> -->
  <div class="accr_box">
    <div class="accordion">
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
            (click)="isManual = !isManual" data-bs-target="#manualAdjustment" aria-expanded="false"
            aria-controls="manualAdjustment">
            Manual Adjustment
          </button>
        </h2>
        <div id="manualAdjustment" class="accordion-collapse collapse">
          <div class="accordion-body p-0">
            <div class="createbot_box mt-3">
              <!-- <div class="row">
                <div class="col-lg-12">
                  <div class="inputgrp_box">
                    <div class="w-100 input-group">
                      <label class="grey">Low price</label>
                      <input aria-label="Username" aria-describedby="basic-addon1" name="lowerPrice"
                        class="form-control" type="text" min="0.000001" (wheel)="onWheel($event)"
                        (input)="handleTradeChange($event)" [ngModel]="formValue.lowerPrice" pattern="[0-9]*[.]?[0-9]*"
                        [appDecimalLimit]="pairData.secondFloatDigit" decimals />
                    </div>
                    <span class="required" *ngIf="serverErrors?.lowerPrice">{{
                      serverErrors.lowerPrice
                      }}</span>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="inputgrp_box">
                    <div class="w-100 input-group">
                      <label class="grey">High price</label>
                      <input aria-label="Username" aria-describedby="basic-addon1" name="upperPrice"
                        class="form-control" type="text" min="0.000001" (wheel)="onWheel($event)"
                        (input)="handleTradeChange($event)" (input)="handleTradeChange($event)"
                        [ngModel]="formValue.upperPrice" pattern="[0-9]*[.]?[0-9]*"
                        [appDecimalLimit]="pairData.secondFloatDigit" decimals />
                    </div>
                    <span class="required" *ngIf="serverErrors?.upperPrice">{{
                      serverErrors.upperPrice
                      }}</span>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="inputgrp_box">
                    <div class="w-100 input-group">
                      <label class="grey">Grid step, %</label>
                      <input aria-label="Username" aria-describedby="basic-addon1" name="gridStepPercent"
                        class="form-control" type="text" min="0.000001" (wheel)="onWheel($event)"
                        (input)="handleTradeChange($event)" [ngModel]="formValue.gridStepPercent"
                        [appDecimalLimit]="pairData.secondFloatDigit" decimals />
                    </div>
                    <span class="required" *ngIf="serverErrors?.gridStepPercent">{{
                      serverErrors.gridStepPercent
                      }}</span>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="inputgrp_box">
                    <div class="w-100 input-group">
                      <label class="grey">Grid levels ({{minGrid}}-{{maxGrid}})</label>
                      <input aria-label="Username" aria-describedby="basic-addon1" name="grids" class="form-control"
                        type="text" min="0.000001" (wheel)="onWheel($event)" (input)="handleTradeChange($event)"
                        [ngModel]="formValue.grids" [appDecimalLimit]="0" decimals />
                    </div>
                    <span class="required" *ngIf="serverErrors?.grids">{{
                      serverErrors.grids
                      }}</span>
                  </div>
                </div>
              </div> -->
              <div class="row">
                <div class="col-lg-12">
                  <div class="inputgrp_box">
                    <div class="w-100 input-group">
                      <label class="grey">Buy Investment %</label>
                      <input aria-label="Username" aria-describedby="basic-addon1" name="buyPercentage"
                        class="form-control" type="text" min="0.000001" (wheel)="onWheel($event)"
                        (input)="handleTradeChange($event)" [ngModel]="formValue.buyPercentage"
                        value="formValue.buyPercentage" pattern="[0-9]*[.]?[0-9]*"
                        [appDecimalLimit]="pairData.secondFloatDigit" decimals />
                    </div>
                    <span class="required" *ngIf="serverErrors?.buyPercentage">{{
                      serverErrors.buyPercentage
                      }}</span>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="inputgrp_box">
                    <div class="w-100 input-group">
                      <label class="grey">Buy Count</label>
                      <input aria-label="Username" aria-describedby="basic-addon1" name="buyCount" class="form-control"
                        type="text" min="0.000001" (wheel)="onWheel($event)" (input)="handleTradeChange($event)"
                        [ngModel]="formValue.buyCount" pattern="[0-9]*[.]?[0-9]*"
                        [appDecimalLimit]="pairData.secondFloatDigit" decimals />
                    </div>
                    <span class="required" *ngIf="serverErrors?.buyCount">{{
                      serverErrors.buyCount
                      }}</span>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="inputgrp_box">
                    <div class="w-100 input-group">
                      <label class="grey">Sell Investment %</label>
                      <input aria-label="Username" aria-describedby="basic-addon1" name="sellPercentage"
                        class="form-control" type="text" min="0.000001" (wheel)="onWheel($event)"
                        (input)="handleTradeChange($event)" (input)="handleTradeChange($event)"
                        [ngModel]="formValue.sellPercentage" pattern="[0-9]*[.]?[0-9]*" value="formValue.sellPercentage"
                        [appDecimalLimit]="pairData.secondFloatDigit" decimals />
                    </div>
                    <span class="required" *ngIf="serverErrors?.sellPercentage">{{
                      serverErrors.sellPercentage
                      }}</span>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="inputgrp_box">
                    <div class="w-100 input-group">
                      <label class="grey">Sell Count</label>
                      <input aria-label="Username" aria-describedby="basic-addon1" name="sellCount" class="form-control"
                        type="text" min="0.000001" (wheel)="onWheel($event)" (input)="handleTradeChange($event)"
                        [ngModel]="formValue.sellCount" pattern="[0-9]*[.]?[0-9]*"
                        [appDecimalLimit]="pairData.secondFloatDigit" decimals />
                    </div>
                    <span class="required" *ngIf="serverErrors?.sellCount">{{
                      serverErrors.sellCount
                      }}</span>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="inputgrp_box">
                    <div class="w-100 input-group">
                      <label class="grey">Profit %</label>
                      <input aria-label="Username" aria-describedby="basic-addon1" name="profitPercentage"
                        class="form-control" type="text" max="100" (wheel)="onWheel($event)"
                        (input)="handleTradeChange($event)" [ngModel]="formValue.profitPercentage"
                        pattern="[0-9]*[.]?[0-9]*" [appDecimalLimit]="pairData.profitPercentage" decimals />
                    </div>
                    <span class="required" *ngIf="serverErrors?.profitPercentage">{{
                      serverErrors.profitPercentage
                      }}</span>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="inputgrp_box">
                    <div class="w-100 input-group">
                      <label class="grey">Buy %</label>
                      <input aria-label="Username" aria-describedby="basic-addon1" name="buyProfitPercentage"
                        class="form-control" type="text" min="0.000001" (wheel)="onWheel($event)"
                        (input)="handleTradeChange($event)" [ngModel]="formValue.buyProfitPercentage"
                        pattern="[0-9]*[.]?[0-9]*" [appDecimalLimit]="pairData.buyProfitPercentage" decimals />
                    </div>
                    <span class="required" *ngIf="serverErrors?.buyProfitPercentage">{{
                      serverErrors.buyProfitPercentage
                      }}</span>
                  </div>
                </div>
              </div>
              <!-- <div class="boxFlexText mb-3">
                <p _ngcontent-ng-c446327758="" class="bot_preview_title mb-0">
                  <i _ngcontent-ng-c446327758="" class="bi bi-info-circle-fill ms-2"></i>
                  Stop Loss
                </p>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" [(ngModel)]="isChecked" />
                </div>
              </div>
              <div *ngIf="isChecked">
                <div class="inputgrp_box">
                  <div class="w-100 input-group">
                    <label class="grey"> price</label>
                    <input aria-label="Username" aria-describedby="basic-addon1" name="stopLoss" class="form-control"
                      value="{{formValue.stopLoss}}" type="number" min="0.000001" (wheel)="onWheel($event)"
                      (input)="handleTradeChange($event)" />
                  </div>
                  <span class="required" *ngIf="serverErrors?.stopLoss">{{
                    serverErrors.stopLoss
                    }}</span>
                </div>
              </div>
              <div class="boxFlexText mb-3">
                <p _ngcontent-ng-c446327758="" class="bot_preview_title mb-0">
                  <i _ngcontent-ng-c446327758="" class="bi bi-info-circle-fill ms-2"></i>
                  Take Profit
                </p>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault"
                    [(ngModel)]="isChecked2" />
                </div>
              </div>
              <div *ngIf="isChecked2">
                <div class="inputgrp_box">
                  <div class="w-100 input-group">
                    <label class="grey"> Total PNl,5% </label>
                    <input aria-label="Username" aria-describedby="basic-addon1" name="takeprofitRatio"
                      class="form-control" value="{{formValue.takeprofitRatio}}" type="number" min="0.000001"
                      (wheel)="onWheel($event)" (input)="handleTradeChange($event)" />
                  </div>
                  <span class="required" *ngIf="serverErrors?.takeprofitRatio">{{
                    serverErrors.takeprofitRatio
                    }}</span>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="boxFlexText">
    <p class="bot_preview_title mb-0">
      <i class="bi bi-info-circle-fill me-2" data-tooltip-id="my-tooltip-6"></i>Available for bot use
    </p>
  </div>

  <div class="bot_preview_box mt-3">
    <!-- <div>
      <span>Quote currencyr</span><span class="border_line"></span><span>47.8769638 {{pairData.firstCurrencySymbol}}</span>
    </div> -->
    <div>
      <span class="grey">Wallet Balance</span><span class="border_line"></span><span>{{toFixedDown(wallet?.gridBal,4)}}
        {{pairData.secondCurrencySymbol}}</span>
    </div>
  </div>
  <button type='button' class="primary_btn w-100" *ngIf="!auth.signedIn; else submitbutton" (click)="navigateToLogin()">
    LOGIN
  </button>
  <ng-template #submitbutton>
    <div><button class="continue" (click)="submitForm()" [disabled]="isSubmitting"> {{ isSubmitting ?
        'Processing...' : 'Continue' }}</button></div>
  </ng-template>
</div>
<app-gridBotForm *ngIf="showNext" [botDetails]="createDetails" orderStep="two"
  [orderPlaceDet]="orderPlaceDet"></app-gridBotForm>